<template>
  <div>
    <v-app-bar
      class="glass-topbar"
      style="z-index: 11; left: 0px; border-left-style: hidden"
      outlined
      elevation="0"
      elevate-on-scroll
      clipped
      fixed
    >
      <!-- Logo Wrapper with Hamburger overlay on mobile -->
      <div class="logo-wrapper-topbar" :class="{ 'mobile-logo': $vuetify.breakpoint.smAndDown }" @click="$router.push({ name: 'companies' })" style="cursor: pointer">
        <img src="/logo.png" alt="Logo" class="topbar-logo" />
        <!-- Hamburger Icon overlay for Mobile (only when drawer is closed) -->
        <v-btn
          v-if="$vuetify.breakpoint.smAndDown && !mobileDrawerOpen"
          icon
          @click.stop="toggleMobileDrawer"
          class="mobile-menu-btn-overlay"
        >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </div>
      <!-- Breadcrumb Navigation -->
      <nav
        v-if="!$vuetify.breakpoint.smAndDown && breadcrumbItems.length > 0"
        class="topbar-breadcrumb"
        aria-label="Navigacijska putanja"
      >
        <template v-for="(crumb, i) in breadcrumbItems">
          <router-link
            v-if="crumb.to"
            :key="'crumb-' + i"
            :to="crumb.to"
            :title="crumb.label"
            class="breadcrumb-link"
          >{{ crumb.label }}</router-link>
          <span
            v-else-if="crumb.isCategory"
            :key="'crumb-cat-' + i"
            :title="crumb.label"
            class="breadcrumb-category"
          >{{ crumb.label }}</span>
          <span
            v-else
            :key="'crumb-active-' + i"
            :title="crumb.label"
            class="breadcrumb-active"
          >{{ crumb.label }}</span>
          <i
            v-if="i < breadcrumbItems.length - 1"
            :key="'sep-' + i"
            class="mdi mdi-chevron-right breadcrumb-sep"
          ></i>
        </template>
      </nav>

      <component :is="content" style="flex-shrink: 50"></component>

      <!-- Certificate Expiration Warning -->
      <v-spacer style="flex-shrink: 100"></v-spacer>
      <div
        v-if="certificateWarning"
        class="certificate-warning mr-4 blink-warning"
        @click="showCertificateModal"
        style="cursor: pointer"
      >
        <span class="red--text text--darken-2 font-weight-bold">
          {{ certificateWarning }}
        </span>
      </div>

      <!-- User Manual Icon -->
      <div v-if="!$vuetify.breakpoint.smAndDown" class="ml-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              icon
              @click="navigateToUserManual"
              class="glass-icon-btn"
            >
              <v-icon>mdi-book-open-page-variant</v-icon>
            </v-btn>
          </template>
          <span>Korisnički priručnik</span>
        </v-tooltip>
      </div>

      <v-menu
        bottom
        :close-on-content-click="false"
        v-model="menu"
        offset-y
        nudge-bottom="10"
        content-class="glass-menu-dropdown"
      >
        <template v-slot:activator="{ on: onMenu }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                text
                class="glass-avatar-btn"
              >
                <v-badge
                  :content="unpaidBillingCount"
                  :value="isAdmin && unpaidBillingCount > 0"
                  color="error"
                  overlap
                  class="bright-red-badge"
                >
                  <v-avatar size="36" class="glass-avatar" v-on="onMenu">{{
                    avatar
                  }}</v-avatar>
                </v-badge>
              </v-btn>
            </template>
            <span>Račun</span>
          </v-tooltip>
        </template>
        <account :menu="menu" :unpaid-billing-count="unpaidBillingCount"></account>
      </v-menu>

      <!-- Notification Icon Button with Dropdown -->
      <div
        v-if="!$vuetify.breakpoint.smAndDown"
        class="ml-2"
        style="position: relative"
      >
        <v-btn
          ref="notificationButton"
          icon
          @click="toggleNotifications"
          class="notification-icon-btn"
        >
          <v-badge
            :content="unreadNotificationsCount"
            :value="unreadNotificationsCount > 0"
            color="error"
            overlap
            class="bright-red-badge"
          >
            <v-icon>mdi-bell-outline</v-icon>
          </v-badge>
        </v-btn>

        <!-- Notification Dropdown -->
        <NotificationDropdown
          v-if="showDropdown"
          ref="notificationDropdown"
          :show="showDropdown"
          :notifications="sortedNotifications"
          :unread-count="unreadNotificationsCount"
          @close="closeDropdown"
          @show-all="navigateToAllNotifications"
          @notification-click="openNotificationDetail"
        />
      </div>

      <!-- Hidden Help Button -->
      <div v-if="false" style="padding: 5px 0px 0px 0px">
        <HelpButton :helpMode="getRoute()"></HelpButton>
      </div>
      <euro-calc-dialog ref="euroCalcDialog"></euro-calc-dialog>

      <!-- Existing Notification Modal (za kompatibilnost) -->
      <notification
        ref="notification"
        :showNotif="showNotif"
        :notification="importantNotif"
      ></notification>

      <!-- Notification Detail Dialog -->
      <NotificationDetailDialog
        v-if="selectedNotification"
        :show="showDetailDialog"
        :notification="selectedNotification"
        @close="closeNotificationDetail"
        @confirmed="handleNotificationConfirmed"
      />
    </v-app-bar>

    <!-- Toast Notification Container -->
    <div class="notification-toast-container">
      <NotificationToast
        v-for="toast in activeToasts"
        :key="toast.key"
        :notification="toast.notification"
        :duration="8000"
        @click="handleToastClick"
        @close="handleToastClose"
      />
    </div>
  </div>
</template>
<script>
import CompaniesTopBar from '@/components/top-bar/components/CompaniesTopBar'
import CompanyTopBar from '@/components/top-bar/components/CompanyTopBar'
import PointOfSaleTopBar from '@/components/top-bar/components/PointOfSaleTopBar'
import CashRegisterTopBar from '@/components/top-bar/components/CashRegisterTopBar'
import AbstractRegisterTopBar from '@/components/top-bar/components/AbstractRegisterTopBar'
import applicationSettings from '@/mixins/applicationSettings'
import Account from '@/components/top-bar/components/account/Account'
import EuroCalcDialog from '@/components/top-bar/components/EuroCalcDialog'
import Notification from '@/components/top-bar/components/Notification'
import NotificationDropdown from '@/components/top-bar/components/NotificationDropdown'
import NotificationDetailDialog from '@/components/top-bar/components/NotificationDetailDialog'
import NotificationToast from '@/components/top-bar/components/NotificationToast'
import state from '@/state'
import { auth, df } from '@/plugins/firebase'
import tables from '@/mixins/tables'

export default {
  components: { CompaniesTopBar, CompanyTopBar, PointOfSaleTopBar, CashRegisterTopBar, AbstractRegisterTopBar, Account, EuroCalcDialog, Notification, NotificationDropdown, NotificationDetailDialog, NotificationToast },
  mixins: [applicationSettings, tables],
  inject: ['showMask', 'hideMask', 'showMsgBox'],
  data: function () {
    return {
      content: undefined,
      menu: false,
      unfiskReceipts: [],
      switchOnScreenKeyboard: false,
      listeners: [],
      newVersion: 0,
      newSubversion: 0,
      tooltipDelay: 500,
      showOrderPrintLocationSelection: false,
      locations: [],
      location: undefined,
      importantNotif: undefined,
      showNotif: false,
      confirmation: '',
      certificateWarning: null,
      // Notification dropdown data
      notifications: [],
      unreadNotifications: [],
      showDropdown: false,
      selectedNotification: null,
      showDetailDialog: false,
      // Toast notification data
      shownToasts: [], // Prati koje toaste smo već prikazali
      activeToasts: [], // Lista trenutno aktivnih toasta
      unpaidBillingCount: 0
    }
  },
  computed: {
    color () {
      return 'red'
    },
    avatar () {
      return state.getUser()?.name?.charAt(0)?.toUpperCase() || ''
    },
    unreadNotificationsCount () {
      return this.unreadNotifications.length
    },
    sortedNotifications () {
      // Sortira: nepročitane prvo, zatim po vremenu (najnovije gore)
      return [...this.notifications].sort((a, b) => {
        if (a.readed === b.readed) {
          // Oba ista status, sortiraj po vremenu
          const aTime = typeof a.created === 'number' ? a.created : a.created?.toMillis?.() || 0
          const bTime = typeof b.created === 'number' ? b.created : b.created?.toMillis?.() || 0
          return bTime - aTime // Novije gore
        }
        return a.readed ? 1 : -1 // Nepročitane gore
      })
    },
    isAdmin () {
      return !!(state.getUser()?.roles?.SUPERADMIN || state.getUser()?.roles?.ADMIN)
    },
    mobileDrawerOpen () {
      return state.drawer
    },
    breadcrumbItems () {
      const sideNav = this.$route?.meta?.sideNav
      if (!sideNav || sideNav === 'Companies') return []

      const routeName = this.$route.name
      const routeTitle = this.$route.meta?.title
      const companyId = this.$route.params?.companyId
      const locationId = this.$route.params?.locationId
      const registerId = this.$route.params?.registerId
      const company = state.getCurrentCompany()
      const items = [{ label: 'Firma', to: { name: 'companies' } }]

      if (!company?.name) return items

      const pageTitle = routeTitle
        ? (this.$te(routeTitle) ? this.$t(routeTitle) : routeTitle)
        : null

      const companyNeedsLink = sideNav !== 'Company' || !!pageTitle
      items.push({
        label: company.name,
        to: companyNeedsLink && companyId
          ? { name: 'company.pointsOfSale', params: { companyId } }
          : null
      })

      if (sideNav === 'PointOfSale' || sideNav === 'CashRegister') {
        const location = state.getPointOfSale()
        if (location?.name) {
          const locId = locationId || location.id
          const locationNeedsLink = sideNav === 'CashRegister' || !!pageTitle
          items.push({
            label: location.name,
            to: locationNeedsLink && companyId && locId
              ? { name: 'pointOfSale.cashRegisters', params: { companyId, locationId: locId } }
              : null
          })
        }
      }

      if (sideNav === 'CashRegister') {
        const cashRegister = state.getCashRegister()
        if (cashRegister?.name) {
          const locId = locationId || state.getPointOfSale()?.id
          const regId = registerId || cashRegister.id
          items.push({
            label: cashRegister.name,
            to: pageTitle && companyId && locId && regId
              ? { name: 'cashRegister', params: { companyId, locationId: locId, registerId: regId } }
              : null
          })
        }
      }

      if (pageTitle) {
        const SETTINGS_SUFFIXES = [
          'users', 'printerConfiguration', 'cardConfiguration', 'posConfiguration',
          'organizationalUnitConfiguration', 'fiscalizationEracun', 'communicationConfiguration',
          'floorPlanSettings', 'orderman', 'userData.qrMenu'
        ]
        const isSettings = SETTINGS_SUFFIXES.some(suffix => routeName.endsWith(suffix))
        if (isSettings) {
          items.push({ label: 'Postavke', to: null, isCategory: true })
        }
        items.push({ label: pageTitle, to: null })
      }

      // Neutraliziraj self-linkove (link koji vodi na trenutnu rutu)
      return items.map(item =>
        item.to && item.to.name === routeName
          ? { ...item, to: null, isCategory: true }
          : item
      )
    }
  },
  created () {
    this.setVersionListener()
    this.tooltipDelay = state.getTooltipDelay()
  },
  mounted () {
    if (state.getCurrentCompany().kelner === true) {
      if (state.getOrderPrintLocation() && state.getOrderPrintLocation().id !== '') {
        this.tables()
      } else {
        this.getPointsOfSale()
        this.showOrderPrintLocationSelection = true
      }
    }

    this.setNotificationListener()
    this.setBillingCountListener()
    this.checkCertificateExpiration()

    this.drawer = !this.drawer
    if (this.$route && this.$route.meta) this.setTopBar(this.$route.meta.topBar)

    // Dodaj click-outside listener za notification dropdown
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy () {
    // Detach svih listeners
    this.listeners.forEach(listener => {
      if (listener && typeof listener === 'function') {
        listener()
      }
    })

    // Ukloni click-outside listener
    document.removeEventListener('click', this.handleClickOutside)
  },
  watch: {
    '$route' (to, from) {
      if (to && to.meta) this.setTopBar(to.meta.topBar)
      if (to.params?.companyId !== from?.params?.companyId) {
        this.setBillingCountListener()
      }
    },
    newVersion (val) {
      if (val > state.getVersion()) {
        var currentVersion = state.getVersion() + '.' + state.getSubversion()
        var latestVersion = this.newVersion + '.' + this.newSubversion
        this.showMask(currentVersion, latestVersion)
      }

      if (val <= state.getVersion() && this.newSubversion <= state.getSubversion()) {
        this.hideMask()
      }
    },
    newSubversion (val) {
      if (val > state.getSubversion()) {
        var currentVersion = state.getVersion() + '.' + state.getSubversion()
        var latestVersion = this.newVersion + '.' + this.newSubversion
        this.showMask(currentVersion, latestVersion)
      }

      if (val <= state.getSubversion() && this.newVersion <= state.getVersion()) {
        this.hideMask()
      }
    }
  },
  methods: {
    toggleMobileDrawer () {
      state.setDrawer(!state.drawer)
    },
    async setBillingCountListener () {
      this.unpaidBillingCount = 0
      if (!this.isAdmin) return
      try {
        const aduroId = (await df.doc('project_constants/aikasa_config/').get()).data().aduro_company_id
        const currentCompanyOib = state.getCurrentCompany().oib
        if (!currentCompanyOib) return

        if (!this._billingCache) this._billingCache = {}
        const cached = this._billingCache[currentCompanyOib]
        if (cached && Date.now() - cached.fetchedAt < 21600000) {
          this.unpaidBillingCount = cached.count
          return
        }

        const snap = await df.collection(`receipts/${aduroId}/receipts`)
          .where('type.payer_oib', '==', currentCompanyOib)
          .where('payment.current_status', 'not-in', ['PAID', 'REVERSED'])
          .get()

        this.unpaidBillingCount = snap.size
        this._billingCache[currentCompanyOib] = { count: snap.size, fetchedAt: Date.now() }
      } catch (e) {
        // silently fail — badge stays at 0
      }
    },
    setVersionListener () {
      const listener = df.doc('project_constants/web_version').onSnapshot(doc => {
        this.newVersion = doc.data().version
        this.newSubversion = doc.data().subversion
      })
      this.listeners.push(listener)
    },
    setOrderLocation () {
      state.setOrderPrintLocation(this.location)
      this.tables()
      this.showOrderPrintLocationSelection = false
    },

    setNotificationListener () {
      const query = df.collection(`user_notifications/${auth.currentUser.uid}/notifications`)
        .orderBy('created', 'desc') // Najnovije prvo
        .limit(50) // Limitat za performanse

      const listener = query.onSnapshot((snapshot) => {
        this.notifications = []
        this.unreadNotifications = []

        snapshot.docs.forEach((doc) => {
          const notification = { id: doc.id, ...doc.data() }
          this.notifications.push(notification)

          if (notification.readed === false) {
            this.unreadNotifications.push(notification)
          }
        })

        // Prikaz notifikacije u modalu samo ako ima showImmediately: true
        if (this.unreadNotifications.length > 0) {
          const immediateNotif = this.unreadNotifications.find(n => n.showImmediately === true)

          if (immediateNotif) {
            setTimeout(() => {
              this.importantNotif = immediateNotif
              this.showNotif = true
            }, 2000)
          } else {
            this.showNotif = false
            this.importantNotif = undefined
          }
        } else {
          this.showNotif = false
          this.importantNotif = undefined
        }
        // Prikaži toast za svaku novu nepročitanu notifikaciju (readed: false)
        this.unreadNotifications.forEach((notification) => {
          if (notification.readed === false && !this.shownToasts.includes(notification.id)) {
            this.showToast(notification)
            this.shownToasts.push(notification.id)
          }
        })
      })

      this.listeners.push(listener)
    },
    // submit () {
    //   if (this.checkConfirmation() === false) {
    //     return
    //   }
    //   var userID = state.getCashRegisterUser() && state.getCashRegisterUser().id !== undefined ? state.getCashRegisterUser().id : state.getUser().id
    //   var userName = state.getCashRegisterUser() && state.getCashRegisterUser().name !== undefined ? state.getCashRegisterUser().name + ' ' + state.getCashRegisterUser().surname : state.getUser().name + ' ' + state.getUser().surname
    //   df.doc(`company_notifications/${state.getCurrentCompany().id}/notifications/${this.importantNotif.id}`)
    //     .update({
    //       readed: true,
    //       reader_id: userID,
    //       reader_name: userName,
    //       readed_time: parseInt(Date.now() / 1000)
    //     })
    // },
    getRoute () {
      var result = /([^.]+$)/.exec(this.$route.name)[0]
      return result
    },

    switchKeyboard (value) {
      this.switchOnScreenKeyboard = !value
      state.setOsk(this.switchOnScreenKeyboard)
    },
    openCalc () {
      // EventBus.$emit('open-euro-calc')
      this.$refs.euroCalcDialog.open()
    },
    setTopBar (topBar) {
      if (topBar && topBar !== this.content) this.content = topBar
    },
    async getPointsOfSale () {
      const docRef = df.doc(`user_locations/${auth.currentUser.uid}.${state.getCurrentCompany().id}`)
      const listener = docRef.onSnapshot(doc => {
        var locations = Object.values(doc.data().locations)
        locations.forEach((location, index) => {
          this.locations.push(location)
        })
      })
      this.listeners.push(listener)
    },

    checkCertificateExpiration () {
      const company = state.getCurrentCompany()

      if (!company || !company.cert_data || !company.cert_data.exp_date) {
        this.certificateWarning = null
        return
      }

      const expDate = company.cert_data.exp_date // Unix timestamp in seconds
      const currentDate = Math.floor(Date.now() / 1000) // Current time in seconds
      const daysUntilExpiration = Math.floor((expDate - currentDate) / (60 * 60 * 24))

      if (daysUntilExpiration <= 0) {
        this.certificateWarning = 'Certifikat je istekao!'
      } else if (daysUntilExpiration <= 30) {
        this.certificateWarning = `Certifikat ističe za ${daysUntilExpiration} dana`
      } else {
        this.certificateWarning = null
      }
    },

    navigateToUserManual () {
      window.open('/user-manual', '_blank')
    },

    showCertificateModal () {
      const company = state.getCurrentCompany()
      if (!company || !company.cert_data || !company.cert_data.exp_date) {
        return
      }

      const expDate = company.cert_data.exp_date
      const expirationDate = new Date(expDate * 1000)
      const formattedDate = expirationDate.toLocaleDateString('hr-HR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })

      this.showMsgBox({
        title: 'Upozorenje o isteku certifikata',
        text: `Nakon ${formattedDate} nećete biti u mogućnosti fiskalizirati račune. Molimo obnovite vaš certifikat za fiskalizaciju kako biste neometano mogli fiskalizirati račune.`,
        actions: ['ok'],
        okBtnText: 'U redu',
        width: 550
      })
    },

    toggleNotifications () {
      // Toggle dropdown umjesto navigacije
      this.showDropdown = !this.showDropdown
    },

    closeDropdown () {
      this.showDropdown = false
    },

    openNotificationDetail (notification) {
      this.selectedNotification = notification
      this.showDetailDialog = true
      this.showDropdown = false // Zatvori dropdown
    },

    closeNotificationDetail () {
      this.showDetailDialog = false
      this.selectedNotification = null
    },

    navigateToAllNotifications () {
      this.showDropdown = false

      // Ista logika kao prije
      let targetModifier = ''
      const sideNav = this.$route?.meta?.sideNav

      switch (sideNav) {
        case 'Company':
          targetModifier = 'company'
          break
        case 'PointOfSale':
        case 'CashRegister':
          targetModifier = 'pointOfSale'
          break
        default:
          targetModifier = 'company'
      }

      // Provjeri da li je companyId dostupan
      const companyId = this.$route.params?.companyId || state.getCurrentCompany()?.id

      if (!companyId) {
        // Ako nismo u kontekstu kompanije, prikaži poruku
        this.showMsgBox({
          title: 'Odabir kompanije',
          text: 'Molimo odaberite kompaniju kako biste vidjeli obavijesti.',
          actions: ['ok'],
          okBtnText: 'U redu',
          width: 400
        })
        return
      }

      // Provjeri da li je locationId potreban (za pointOfSale rute)
      const locationId = this.$route.params?.locationId

      if (targetModifier === 'pointOfSale' && locationId) {
        this.$router.push({
          name: `${targetModifier}.notifications`,
          params: { companyId, locationId }
        })
      } else {
        this.$router.push({
          name: `${targetModifier}.notifications`,
          params: { companyId }
        })
      }
    },

    handleNotificationConfirmed () {
      // Nakon potvrde, osvježi listener (automatski)
      this.closeNotificationDetail()
    },

    handleClickOutside (event) {
      const dropdown = this.$refs.notificationDropdown
      const button = this.$refs.notificationButton

      if (this.showDropdown && dropdown && button) {
        const dropdownEl = dropdown.$el || dropdown
        const buttonEl = button.$el || button

        if (!dropdownEl.contains(event.target) && !buttonEl.contains(event.target)) {
          this.closeDropdown()
        }
      }
    },

    // Toast notification methods
    showToast (notification) {
      // Dodaj toast u listu aktivnih toasta
      // Koristimo notification.id + timestamp za garantirano jedinstveni key
      this.activeToasts.push({
        id: notification.id,
        notification: notification,
        key: `${notification.id}-${Date.now()}-${Math.random()}` // Garantirano jedinstveni key
      })
    },

    handleToastClick (notification) {
      // Otvori notifikaciju u detail dialogu
      this.openNotificationDetail(notification)

      // Ukloni toast iz liste
      this.removeToast(notification.id)
    },

    handleToastClose (notification) {
      // Ukloni toast iz liste
      this.removeToast(notification.id)
    },

    removeToast (notificationId) {
      const index = this.activeToasts.findIndex(t => t.id === notificationId)
      if (index !== -1) {
        this.activeToasts.splice(index, 1)
      }
    }
  }
}
</script>
<style scoped>
/* Glass Morphism TopBar */
.glass-topbar {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border-bottom: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 4px 24px rgba(0, 179, 190, 0.08) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Mobile Menu Button Overlay */
.mobile-menu-btn-overlay {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  background: rgba(255, 255, 255, 0.95) !important;
  border-radius: 50% !important;
  border: 2px solid rgba(57, 137, 201, 0.3) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.2) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  width: 36px !important;
  height: 36px !important;
}

.mobile-menu-btn-overlay:hover {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.35) !important;
  border-color: rgba(57, 137, 201, 0.5) !important;
  transform: translate(-50%, -50%) scale(1.05) !important;
}

.mobile-menu-btn-overlay .v-icon {
  color: #3989c9 !important;
  font-size: 22px !important;
  transition: all 0.3s ease;
}

.glass-topbar::v-deep .v-toolbar__content {
  padding: 4px 16px;
}

/* Logo Wrapper */
.logo-wrapper-topbar {
  display: flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px 12px 0 0;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(10px);
  border: none;
  transition: all 0.3s ease;
  margin-right: 8px;
  margin-left: -16px;
  position: relative;
}

.logo-wrapper-topbar:hover {
  background: rgba(255, 255, 255, 0.8);
  border-color: rgba(0, 179, 190, 0.3);
  box-shadow: 0 4px 12px rgba(0, 179, 190, 0.15);
}

.topbar-logo {
  width: 50px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  transition: all 0.3s ease;
}

.logo-wrapper-topbar:hover .topbar-logo {
  filter: drop-shadow(0 2px 8px rgba(0, 179, 190, 0.3));
  transform: scale(1.05);
}

/* Mobile Logo Wrapper */
.logo-wrapper-topbar.mobile-logo {
  margin-left: 0;
  padding: 4px 8px;
}

.logo-wrapper-topbar.mobile-logo .topbar-logo {
  width: 40px;
}

/* Glass Button Group - Soft Shadow Style */
.glass-btn-group {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  overflow: visible !important;
}

.glass-icon-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(57, 137, 201, 0.15) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  margin: 0 !important;
}

.glass-icon-btn:hover {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  border-color: rgba(57, 137, 201, 0.3) !important;
  transform: translateY(-1px);
}

.glass-icon-btn .v-icon {
  color: #3989c9 !important;
  transition: all 0.3s ease;
}

.glass-icon-btn:hover .v-icon {
  color: #3989c9 !important;
}

/* Glass Avatar */
.glass-avatar-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.glass-avatar {
  background: linear-gradient(
    135deg,
    rgba(0, 179, 190, 0.9) 0%,
    rgba(57, 137, 201, 0.85) 50%,
    rgba(97, 84, 164, 0.9) 100%
  ) !important;
  border: 2px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 12px rgba(0, 179, 190, 0.3);
  font-size: 18px !important;
  font-weight: 700;
  color: white !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.glass-avatar-btn:hover .glass-avatar {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 179, 190, 0.5);
  border-color: rgba(255, 255, 255, 1);
}

/* Notification Icon Button */
.notification-icon-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(57, 137, 201, 0.15) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  width: 40px !important;
  height: 40px !important;
}

.notification-icon-btn:hover {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  border-color: rgba(57, 137, 201, 0.3) !important;
  transform: translateY(-1px);
}

.notification-icon-btn .v-icon {
  color: #3989c9 !important;
  transition: all 0.3s ease;
  font-size: 20px !important;
}

.notification-icon-btn:hover .v-icon {
  color: #3989c9 !important;
}

.notification-icon-btn .v-badge__badge {
  font-size: 10px !important;
  height: 18px !important;
  min-width: 18px !important;
  padding: 0 4px !important;
}

/* Bright Red Badge */
.bright-red-badge::v-deep .v-badge__badge {
  background: #EF4444 !important;
  background-color: #EF4444 !important;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.5) !important;
  font-weight: 700 !important;
  border: none !important;
  animation: badge-pulse 2s ease-in-out infinite !important;
}

.notification-icon-btn .v-badge__badge.v-badge__badge {
  background: rgba(239, 68, 68, 0.9) !important;
  background-color: rgba(239, 68, 68, 0.9) !important;
  animation: badge-pulse 2s ease-in-out infinite !important;
}

@keyframes badge-pulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.4);
  }
  50% {
    transform: scale(1.15);
    box-shadow: 0 4px 16px rgba(239, 68, 68, 0.7);
  }
}

/* Glass Menu Dropdown */
::v-deep .glass-menu-dropdown {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.15) !important;
  overflow: hidden;
  z-index: 1001 !important;
}

/* Breadcrumb Navigation */
.topbar-breadcrumb {
  display: flex;
  align-items: stretch;
  height: 100%;
  gap: 0;
  padding: 0 4px 0 8px;
  margin-left: 20px;
  flex-shrink: 1;
  max-width: 900px;
  overflow: hidden;
  white-space: nowrap;
}

/* Baza za sve linkove — zajednički reset */
.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none !important;
  padding: 0 8px;
  border-radius: 0;
  transition: color 0.15s ease, background 0.15s ease;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 1;
  min-width: 0;
  max-width: 300px;
  cursor: pointer;
}

/* Razina 1 — Moje firme */
.topbar-breadcrumb > .breadcrumb-link:nth-child(1) {
  font-size: 14px;
  font-weight: 400;
  color: #94A3B8;
  flex-shrink: 0;
  max-width: none;
}

/* Razina 2 — Naziv tvrtke */
.topbar-breadcrumb > .breadcrumb-link:nth-child(3) {
  font-size: 14px;
  font-weight: 500;
  color: #64748B;
  flex-shrink: 20;
}

/* Razina 3 — Prodajno mjesto */
.topbar-breadcrumb > .breadcrumb-link:nth-child(5) {
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  flex-shrink: 10;
}

/* Hover — suptilna tirkizna pozadina */
.breadcrumb-link:hover {
  color: #00BCD4 !important;
  text-decoration: none !important;
  background-color: rgba(0, 188, 212, 0.07);
}

/* Kategorija (npr. Postavke) — nije link, nije aktivna */
.breadcrumb-category {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #64748B;
  padding: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 5;
  min-width: 0;
}

/* Razina 4 — Aktivna stavka (blagajna / trenutni modul) */
.breadcrumb-active {
  display: inline-flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #00BCD4;
  padding: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: 0;
  max-width: 350px;
}

/* Separator */
.breadcrumb-sep {
  font-size: 13px;
  color: #CBD5E1;
  line-height: 1;
  flex-shrink: 0;
  margin: 0 2px;
  display: inline-flex;
  align-items: center;
  align-self: center;
}

/* Legacy Styles */
.notifications {
  overflow-y: scroll;
  color: black;
  font-size: 18px;
  max-height: 400px;
  overflow-y: scroll;
}

.redText {
  color: red;
}

.whiteText {
  color: white;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

/* Blinking animation for certificate warning */
.blink-warning {
  animation: blink-animation 1.5s ease-in-out infinite;
}

@keyframes blink-animation {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

.certificate-warning:hover {
  opacity: 0.8;
}

/* Toast Notification Container */
.notification-toast-container {
  position: fixed;
  top: 80px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  pointer-events: none;
}

.notification-toast-container > * {
  pointer-events: all;
}

@media (max-width: 768px) {
  .notification-toast-container {
    top: 70px;
    right: 10px;
    left: 10px;
    align-items: center;
  }

  .glass-topbar::v-deep .v-toolbar__content {
    padding: 4px 8px;
  }
}
</style>
